export const SET_GASTOS_FIJOS = "SET_GASTOS_FIJOS";
